<div id="not-loggedin" class="main-container">
  <div class="container-fluid" style="padding: 0">
    <router-outlet name="master"></router-outlet>
  </div>
</div>
